import React, { Component } from "react";
import { API_URL } from "../Config";
import {
  Button,
  TextField,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Typography,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import {TermsAndCondition , PrivacyPolicy , Copyright} from "../DumbAssets/StaticForms"
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      showPassword: false,
      isChecked: false,
      connectionError: "",
      error: {},
      open: false,
      severity: "",
      alertmsg: "",
      disabled: false,
    };
  }
  componentDidMount() {
    if (
      localStorage.getItem("checkbox") &&
      localStorage.getItem("username") !== ""
    ) {
      this.setState({
        isChecked: true,
        email: localStorage.getItem("username"),
        password: localStorage.getItem("password"),
      });
    }
    localStorage.setItem("rows", 10);
  }

  validateForm = () => {
    const validEmailRegex = RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    let error = {};
    let { email, password } = this.state;

    if (email === "") {
      error["email"] = "Please enter email address";
    } else if (!validEmailRegex.test(email.trim())) {
      error["email"] = "Invalid email address";
    }
    if (password === "") {
      error["password"] = "Please enter password";
    }
    this.setState({ error });
    if (Object.keys(error).length === 0) {
      return true;
    } else {
      return false;
    }
  };

  handleChange = (e) => {
    let {
      target: { name, value },
    } = e;
    let { error } = this.state;
    if (name !== "") {
      delete error[name];
      this.setState({ connectionError: "" });
    }
    this.setState({ [name]: value });
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleMouseDownPassword = (e) => {
    e.preventDefault();
  };

  onSubmit = (e) => {
    e.preventDefault();
    let checked = this.validateForm();
    if (!checked) {
      return;
    } else {
      this.setState({ disabled: true });

      let query = `${API_URL}/login?email=${this.state.email}&password=${this.state.password}`;
      fetch(query, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          // query: Query,
          // variables: Variables,
        }),
        headers: {
          "Content-type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          this.setState({ disabled: false });
          if (res.data.refreshOtpToken) {
            // Send to OTP verification screen
            localStorage.setItem("refreshtoken", res.data.refreshOtpToken);
            localStorage.setItem("email", res.data.email);
            localStorage.setItem(
              "name",
              `${res.data.firstname}` +
                `${res.data.lastname == null ? "" : " " + res.data.lastname}`
            );

            localStorage.setItem(
              "userInitials",
              `${res.data.firstname.substring(0, 1)}` +
                `${
                  res.data.lastname == null
                    ? ""
                    : res.data.lastname.substring(0, 1)
                }`
            );
            this.props.history.push({
              pathname: "/login/1",
              state: { check: "check" },
            });
          } else {
            this.setState({
              connectionError: res.data.message,
            });
          }
        })
        .catch((e) => {
          this.setState({
            disabled: false,
            connectionError: e.toString().substring(11, e.length),
          });
        });
    }
  };
  rememberCheck = (e) => {
    let { checked } = e.target;
    this.setState({ isChecked: checked });
  };

  forgotpassword = () => {
    Cookies.remove("token");
    Cookies.remove("mail");
  };

  render() {
    return (
      <div>
        <div className="logo">
          {/* <img src={logo} alt="RCM Logo"></img> */}
        </div>
        <h4>LOG IN</h4>
        <form noValidate>
          <TextField
            value={this.state.email}
            margin="normal"
            fullWidth
            name="email"
            label="Email Address"
            autoComplete="off"
            autoFocus
            onChange={this.handleChange}
            helperText={this.state.error.email}
          />

          <TextField
            className="loginPassword"
            margin="normal"
            name="password"
            label="Password"
            type={this.state.showPassword ? "text" : "password"}
            value={this.state.password}
            onChange={this.handleChange}
            helperText={this.state.error.password}
          />

          {this.state.connectionError ? (
            <div className="connectionError">
              <p>{this.state.connectionError}</p>
            </div>
          ) : (
            ""
          )}
          <Grid container className="rememberpart">
            <Grid item xs>
              {/* <FormControlLabel
                control={
                  <Checkbox
                    name="checkedB"
                    color="primary"
                    checked={this.state.isChecked}
                  />
                }
                label="Remember Me"
                onClick={this.rememberCheck}
              /> */}
            </Grid>
            <Grid style={{ padding: "10px" }} item xs>
              <Link
                to="/forgotpassword"
                state={{ check: "check" }}
                onClick={this.forgotpassword}
                variant="body2"
              >
                Forgot password?
              </Link>
            </Grid>
          </Grid>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            className="loginbtn"
            onClick={this.onSubmit}
            disabled={this.state.disabled}
          >
            LOGIN
          </Button>
        </form>
        <Grid container className="createAccount">
          <Grid item xs>
            <ul>
              <li>
                <Link
                  to="/"
                  onClick={() => this.setState({ termOfUseOpen: true })}
                >
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  onClick={() => this.setState({ privacyDialogOpen: true })}
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  onClick={() => this.setState({ regulatoryDialogOpen: true })}
                >
                  Regulatory
                </Link>
              </li>
            </ul>
          </Grid>
        </Grid>
        {/********* TERMS OF USE / PRIVACY POLICY / COPYRIGHT *************** */}
        <Dialog
          open={
            this.state.termOfUseOpen ||
            this.state.privacyDialogOpen ||
            this.state.regulatoryDialogOpen
          }
          onClose={() =>
            this.setState({
              termOfUseOpen: false,
              privacyDialogOpen: false,
              regulatoryDialogOpen: false,
            })
          }
        >
          <DialogTitle id="responsive-dialog-title" className="staticDialogTitle">
            <Typography className="staticDialogTitleTypo">
              {" "}
              {this.state.termOfUseOpen
                ? "Terms of Use"
                : this.state.privacyDialogOpen
                ? "Privacy Policy"
                : this.state.regulatoryDialogOpen
                ? "Regulatory"
                : ""}
            </Typography>
          </DialogTitle>
          <DialogContent>
            {this.state.termOfUseOpen ? <TermsAndCondition /> :this.state.privacyDialogOpen ? <PrivacyPolicy/> :this.state.regulatoryDialogOpen ? <Copyright />:"" }
          </DialogContent>
        </Dialog>
        {/********* END OF TERMS OF USE / PRIVACY POLICY / COPYRIGHT *************** */}
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    addRole: (route) => {
      dispatch({ type: "Role", payload: route });
    },
  };
};
// export default Login;
export default connect(null, mapDispatchToProps)(Login);
